var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalResponses(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7126 12.4104C15.7126 12.7696 15.5699 13.114 15.3159 13.368C15.062 13.6219 14.7175 13.7646 14.3584 13.7646H5.43986C5.08074 13.7647 4.73636 13.9074 4.48246 14.1614L2.99152 15.6523C2.92429 15.7195 2.83864 15.7653 2.7454 15.7839C2.65215 15.8024 2.5555 15.7929 2.46767 15.7565C2.37983 15.7201 2.30476 15.6585 2.25194 15.5795C2.19911 15.5004 2.17091 15.4075 2.1709 15.3124V4.28544C2.1709 3.92629 2.31357 3.58186 2.56752 3.3279C2.82148 3.07395 3.16592 2.93127 3.52507 2.93127H14.3584C14.7175 2.93127 15.062 3.07395 15.3159 3.3279C15.5699 3.58186 15.7126 3.92629 15.7126 4.28544V12.4104Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55566 8.3479H12.3265M5.55566 11.0563H9.61816M5.55566 5.63965H10.9723",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalResponses);
export default __webpack_public_path__ + "static/media/total-responses.15b3c6108acc1ace7b721cb7cecca039.svg";
export { ForwardRef as ReactComponent };